var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGooglecalendar = function SvgGooglecalendar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#googlecalendar_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M18.315 5.684H5.684v12.631h12.631z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EA4335",
    d: "M18.316 24 24 18.314l-2.842-.485-2.842.485-.52 2.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#188038",
    d: "M0 18.315v3.79c0 1.046.848 1.894 1.895 1.894h3.79l.583-2.842-.584-2.842-3.097-.485z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1967D2",
    d: "M24 5.684v-3.79A1.894 1.894 0 0 0 22.105 0h-3.79q-.518 2.115-.518 3.112 0 .998.519 2.572 1.885.54 2.842.54.956 0 2.842-.54"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FBBC04",
    d: "M24 5.684h-5.684v12.631h5.685z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#34A853",
    d: "M18.315 18.316H5.684v5.685h12.631z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4285F4",
    d: "M18.316 0H1.895A1.894 1.894 0 0 0 0 1.895v16.42h5.684V5.686h12.632z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4285F4",
    d: "M8.274 15.483q-.709-.478-.977-1.4l1.096-.452q.15.568.52.88.371.313.898.312.537 0 .923-.327.387-.328.387-.832 0-.516-.407-.843-.409-.327-1.02-.327H9.06v-1.085h.568q.526 0 .886-.284t.36-.778a.86.86 0 0 0-.322-.703q-.322-.263-.817-.264-.483 0-.767.258a1.5 1.5 0 0 0-.414.633l-1.084-.452q.214-.611.794-1.078t1.48-.468q.667 0 1.198.258t.832.713q.3.457.3 1.025 0 .58-.28.982a1.9 1.9 0 0 1-.687.618v.064c.351.145.656.382.881.687q.345.461.345 1.106 0 .644-.327 1.149-.328.504-.902.794t-1.293.29a2.68 2.68 0 0 1-1.538-.476m6.731-5.438-1.203.87-.601-.913 2.158-1.557h.827v7.344h-1.18z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "googlecalendar_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgGooglecalendar;